import {
  isWandbArtifactRef,
  isWeaveObjectRef,
  type ObjectRef,
} from '@wandb/weave/react';
import React, {type FC} from 'react';

import {SmallArtifactRef} from './SmallArtifactRef';
import {SmallWeaveRef} from './SmallWeaveRef';

export const SmallRef: FC<{
  objRef: ObjectRef;
  iconOnly?: boolean;
  noLink?: boolean;
  displayName?: string;
  // Latest version digest of the referenced object. When provided alongside
  // `displayName` and the ref points at an older version, a version tag is
  // appended so the pinned version is distinguishable from the latest.
  latestVersionHash?: string;
}> = ({objRef, ...props}) => {
  if (isWeaveObjectRef(objRef)) {
    return <SmallWeaveRef objRef={objRef} {...props} />;
  }
  if (isWandbArtifactRef(objRef)) {
    return <SmallArtifactRef objRef={objRef} {...props} />;
  }
  return <div>[Error: non wandb ref]</div>;
};
